<template>
	<div :style="{ height: bodyHeight + 'px' }" class="home m-body">
		<van-image
			width="3.34rem"
			height="0.96rem"
			style="display: block;margin: 0.32rem auto 0.24rem;"
			:src="require('@/assets/images/dayu_m_header.png')"
		></van-image>
		
		<div class="main">
			<div class="info qjc-flex">
				<div class="weather qjc-flex">
					<van-image
						width="1.54rem"
						height="1.7rem"
						:src="weather.img?require('@/assets/images/'+ weather.img +'.png'):''"
					></van-image>
					<dl>
						<dt>{{ weather.temperature }}°C</dt>
						<dd>{{ weather.text }}<span class="place">{{ weather.city }}</span></dd>
					</dl>
				</div>
				<dl class="date qjc-texta-c">
					<dt>{{ time }}</dt>
					<dd class="qjc-fts-22">{{ date }} {{ week }}</dd>
				</dl>
			</div>
			
			<div class="modules">
				<ul class="qjc-clearfix">
					<li @click="to('https://medin.medinhealth.com/#/question?from=dy&user=dayu')" class="qjc-fl">
						<van-image
							width="100%"
							height="2.21rem"
							:src="require('@/assets/images/m_healthVIP.png')"
						></van-image>
						<h4 class="qjc-texta-c qjc-ftw-n qjc-fts-32">健康大数据VIP服务</h4>
					</li>
					<li @click="$router.push('/dayu/m/online')" class="qjc-fl">
						<van-image
							width="100%"
							height="2.21rem"
							:src="require('@/assets/images/dayu_m_online.png')"
						></van-image>
						<h4 class="qjc-texta-c qjc-ftw-n qjc-fts-32">在线咨询</h4>
					</li>
					<li @click="$router.push('/dayu/m/course')" class="qjc-fl">
						<van-image
							width="100%"
							height="2.21rem"
							:src="require('@/assets/images/dayu_m_kcjh.png')"
						></van-image>
						<h4 class="qjc-texta-c qjc-ftw-n qjc-fts-32">课程计划</h4>
					</li>
					<li @click="to('https://shop45145934.m.youzan.com/v2/showcase/homepage?alias=nNubVDg1wp&dc_ps=2588846330684176393.300001')" class="qjc-fl">
						<van-image
							width="100%"
							height="2.21rem"
							:src="require('@/assets/images/m_shop.png')"
						></van-image>
						<h4 class="qjc-texta-c qjc-ftw-n qjc-fts-32">健康商城</h4>
					</li>
				</ul>
			</div>
			
			<div class="health">
				<h3 class="qjc-fts-36">
					健康频道
					<span @click="$router.push('/dayu/m/health')" class="more qjc-ftw-n qjc-fts-24 qjc-fr">查看更多</span>
				</h3>
				
				<van-swipe @change="checkTab" :autoplay="5000" ref="swipe">
					<van-swipe-item v-for="(list,index) in healthList" :key="index">
						<ul v-for="item in list" :key="item.id" class="list qjc-fts-32">
							<li @click="$router.push('/dayu/m/health/detail/'+item.id)">{{ item.title }}</li>
						</ul>
					</van-swipe-item>
				</van-swipe>
				
				<ol class="tabs qjc-flex">
					<li @click="tabClick(index)" v-for="(i,index) in healthList" :key="'tab'+index" :class="{ 'active': index == healthListPage }"></li>
				</ol>
			</div>
			
			
		</div>
		
		<m-footer></m-footer>
		
	</div>
</template>

<script>
	import Vue from 'vue'
	import { Image, Swipe, SwipeItem, Toast } from 'vant'
	Vue.use(Image)
	   .use(Swipe)
	   .use(SwipeItem)
	   .use(Toast);
	
	import MFooter from '@/components/m/Footer'
	
	import { getWeatherInfo, getHealthDy } from '@/utils/axios'
	
	export default{
		name: 'dayumHome',
		data() {
			return {
				bodyHeight: document.documentElement.clientHeight,
				
				weather: {
					img: '',
					text: '--',
					temperature: '--',
					city: '--'
				},//天气状况
				
				date: '--',
				time: '--',
				week: '--',
				
				healthList: [],
				healthListPage: 0,
				
			}
		},
		components: {
			MFooter
		},
		mounted() {
			this.$nextTick(() => {
				this.getWeather();
				this.getTime();
				
				this.getHealthList();
				
			})
		},
		methods: {
			// 获取天气信息 参数：调用api下标
			getWeather(apiListIndex) {
				var getWeatherTime = localStorage.getItem('getWeatherTime'),
					differ = new Date().getTime() - (getWeatherTime?getWeatherTime:0);
				var res = '';
				if(differ > (30 * 60 * 1000)){
					var index = apiListIndex?apiListIndex:0;
					
					// 三条线路
					if(index < 3){
						getWeatherInfo(index).then(data => {
							console.log(data);
							res = data;
							if(res.wea_img){
								
								// 存储接口调取时间，存储数据，三十分钟后再次调取
								localStorage.setItem('getWeatherTime', new Date().getTime());
								localStorage.setItem('weatherInfo', JSON.stringify(res));
								
								this.showWeather(res);
							}else{
								this.getWeather(++index);
							}
							
						})
					}else{
						alert('天气信息获取失败');
					}
					
				}else{
					res = JSON.parse(localStorage.getItem('weatherInfo'));
					if(res.wea_img){
						this.showWeather(res);
					}else{
						localStorage.removeItem('weatherInfo');
					}
				}
				
			},
			//展示天气情况
			showWeather(res){
				// 天气状况
				this.weather.img = res.wea_img;
				this.weather.text = res.wea;// 描述
				this.weather.temperature = res.tem;// 实时气温
				this.weather.city = res.city
				
				// 日期
				// this.date = res.date.split('-').join('/');
				// this.week = res.week;
				
				// 隔三十分钟调取一次
				var that = this;
				setTimeout(() => {
					that.getWeather();
				}, 30 * 60 * 1000);
			},
			
			// 获取健康频列表
			getHealthList(){
				getHealthDy(1,9).then(res => {
					// console.log(res);
					
					if(res.errno == 0){
						// 三条一页
						var list = this.healthList.concat(res.data.list),//只显示9条
							forList = [];
						for(var i=0;i<list.length;i++){
							var last = forList[forList.length-1];
							if(last && last.length < 3){
								last.push(list[i]);
							}else{
								forList.push([list[i]]);
							}
						}
						this.healthList = forList;
						
					}else{
						alert(res.errmsg);
					}
				});
			},
			//指示器
			checkTab(index) {
				this.healthListPage = index;
			},
			// 指示器时间
			tabClick(index) {
				this.$refs.swipe.swipeTo(index);
			},
			
			// 获取时间
			getTime() {
				// 接口无时间,获取当前时间
				var now = new Date();
				this.time = (now.getHours()<10?'0'+now.getHours():now.getHours()) + ':' + (now.getMinutes()<10?'0'+now.getMinutes():now.getMinutes());
				
				// 时间校准(毫秒校准)
				var speed = (60 - now.getSeconds()) * 1000 - now.getMilliseconds();
				
				// 日期
				this.date = now.getFullYear() + '/' + (now.getMonth()+1) + '/' + now.getDate();
				var weeks = ['星期日','星期一','星期二','星期三','星期四','星期五','星期六'];
				this.week = weeks[now.getDay()];
				
				// 周期性一分钟一次
				setTimeout(() => {
					this.getTime();
				}, speed);
				
			},
			
			// 跳转链接
			to(url) {
				window.location.href = url;
			}
			
		}
	}
</script>

<style scoped>
	/* 自定义指示器只能隐藏,否则在ios上会出现文字卡顿停留 */
	.health >>> .van-swipe__indicators{
		visibility: hidden;
	}
</style>
<style lang="scss" scoped>
	.home{
		color: #5FD6FF;
		padding-top: 0.08rem;
		padding-bottom: 1.9rem;
		
		.main{
			margin: 0.24rem;
			
			&>div{
				background: linear-gradient(180deg,rgba(49,92,147,0.5) 0%,rgba(22,47,90,0.5) 100%);
				border-radius: 0.06rem;
				margin-bottom: 0.24rem;
			}
			
			.info{
				justify-content: space-between;
				align-items: center;
				
				.weather{
					justify-content: flex-start;
					align-items: center;
					
					dl{
						margin-left: 0.08rem;
						
						dt{
							font-size: 0.48rem;
							line-height: 0.48rem;
							font-weight: 400;
						}
						dd{
							font-size: 0.28rem;
							line-height: 0.28rem;
							margin-top: 0.16rem;
							
							.place{
								margin-left: 0.2rem;
							}
						}
					}
				}
				.date{
					padding-right: 0.32rem;
					
					dt{
						font-size: 0.72rem;
						line-height: 0.72rem;
					}
					dd{
						line-height: 0.22rem;
						margin-top: 0.16rem;
					}
				}
			}
			
			.modules{
				color: #E3ECFF;
				padding: 0.32rem 0.11rem 0;
				
				li{
					width: 50%;
					padding: 0 0.11rem;
					margin-bottom: 0.24rem;
					
					h4{
						margin-top: 0.12rem;
					}
				}
			}
			
			.health{
				h3{
					font-weight: 500;
					line-height: 0.95rem;
					border-bottom: 0.01rem solid #3D5E90;
					padding: 0 0.32rem;
					
					.more{
						position: relative;
						margin-right: 0.18rem;
						
						&::after{
							position: absolute;
							content: '';
							top: 50%;
							right: -0.18rem;
							width: 0.16rem;
							height: 0.16rem;
							border-top: 0.01rem solid #5FD6FF;
							border-right: 0.01rem solid #5FD6FF;
							transform: translateY(-50%)rotateZ(45deg);
						}
					}
				}
			
				.list{
					padding: 0 0.32rem;
					
					li{
						display: flex;
						align-items: center;
						position: relative;
						height: 1.55rem;
						line-height: 0.4rem;
						
						&::after{
							content: '';
							position: absolute;
							bottom: 0;
							left: 0.09rem;
							right: 0.09rem;
							border-bottom: 0.01rem dashed #3D5E90;
						}
					}
				}
				
				.tabs{
					height: 0.85rem;
					justify-content: center;
					align-items: center;
					
					li{
						width: 0.16rem;
						height: 0.16rem;
						border-radius: 0.02rem;
						background-color: #325D6C;
						margin: 0 0.12rem;
						
						&.active{
							background-color: #86D2ED;
						}
					}
				}
					
			}
			
			.foot{
				color: #6E7EA0;
				margin-top: 0.32rem;
				text-align: center;
			}
			
		}
	}
</style>
